export default __webpack_public_path__ + "static/media/bannerBg.6867e22e.png";